import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Payment } from "../../../../constant/imagePath";
import { Button } from "../../../../stories/Button/Button";
import classes from "./PayoutMethodMobile.module.css";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import PaymentMethodCard from "../../../../stories/PaymentMethodCard/PaymentMethodCard";
import AddPayoutMethod from "../../../../components/Modals/CoachFlow/OnBoarding/AddPayoutMethod/AddPayoutMethod";
import { RemovePayoutMethodModal } from "../../../../components/Modals/CoachFlow/Settings/RemovePayoutMethod/RemovePayoutMethod";

const PayoutMethodMobile = () => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const paymentarray = [
    {
      type: "master",
      title: "Master Card",
      number: ".... 3679",
      description: "This is your default payment method",
    },
    {
      type: "visa",
      title: "Visa Card",
      number: ".... 6543",
      description: "",
    },
  ];
  return (
    <div>
      <Row>
        <Col xs={12} className={[classes.mb32].join(" ")}>
          <Row className={["g-0", classes.paymentCards].join(" ")}>
            {paymentarray.map((item, i) => {
              return (
                <Col md={12} key={i}>
                  <PaymentMethodCard
                    data={item}
                    onRemove={() => setIsRemoving(true)}
                  />
                </Col>
              );
            })}
          </Row>
        </Col>
        <Col xs={12} className={[classes.mt8, classes.mb32].join(" ")}>
          <Button
            primary={true}
            size="Large"
            customStyle={{ width: "100%" }}
            onClick={() => setIsAdding(true)}
          >
            Add new payment method
          </Button>
        </Col>
        <Col sm={12} className={[classes.mb16].join(" ")}>
          <div className={[classes.paylayoutdiv].join(" ")}>
            <img
              src={Payment}
              alt="..."
              className={[classes.paymentimg, classes.mb24].join(" ")}
            />
            <h5
              style={{
                ...Fonts.h5,
                color: Colors.neutralShadesOfNero,
                fontSize: "19px",
                lineHeight: "24px",
              }}
              className={[classes.mb8].join(" ")}
            >
              Make all payouts
              <br />
              through Lytesnap
            </h5>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
              Always get paid and communicate through Lytesnap to ensure you're
              protected under our{" "}
              <span
                style={{ color: Colors.mainBlue }}
                className={[classes.pointer].join(" ")}
              >
                Terms of Service
              </span>
              , cancellation, and other safeguards.
            </p>
          </div>
        </Col>
      </Row>
      <AddPayoutMethod show={isAdding} setShow={setIsAdding} />
      <RemovePayoutMethodModal show={isRemoving} setShow={setIsRemoving} />
    </div>
  );
};

export default PayoutMethodMobile;
